<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="subfolder-add-form-modal-label">
                {{ $root.text(
                    'Add {subfolder}',
                    { subfolder: $root.text($root.contents.subfolder_title, null, false, 'subfolder_title') },
                    true
                ) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            <div v-if="updated" class="alert alert-success" role="alert">
                <div class="row">
                    <div class="col-1" style="max-width: 30px"><i class="far fa-check"></i></div>
                    <div class="col" v-html="updated"></div>
                </div>
            </div>
            <div v-else>
                <form v-on:submit.prevent="onSubmit()">
                    <button type="submit" class="d-none"></button>
                    <div v-if="errors" v-html="errors" class="alert alert-danger" role="alert"></div>

                    <div class="form-group">
                        <label>{{ $root.text($root.contents.folder_title, null, true, 'folder_title') }}</label>
                        <input
                            v-model="folder_name"
                            type="text"
                            class="form-control"
                            :readonly="true"
                        >
                    </div>
                    <div class="form-group">
                        <label for="subfolder-name" id="subfolder-name-label" class="mandatory-label">
                            {{ $root.text(
                                '{subfolder} name',
                                {
                                    subfolder: $root.text(
                                        $root.contents.subfolder_title,
                                        null,
                                        false,
                                        'subfolder_title'
                                    )
                                },
                                true
                            ) }} *
                        </label>
                        <input
                            v-model="subfolder.name"
                            type="text"
                            id="subfolder-name"
                            class="form-control mandatory-field"
                            :readonly="updating"
                            v-on:keyup="$root.unHighlightErrors('subfolder-name')"
                            v-on:change="$root.unHighlightErrors('subfolder-name')"
                        >
                    </div>
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input
                                v-model="subfolder.related_assets"
                                type="checkbox"
                                class="custom-control-input"
                                id="subfolder-related_assets"
                                :disabled="updating"
                            >
                            <label class="custom-control-label" for="subfolder-related_assets">
                                {{ $root.text('Related {resources} field',
                                    { resources: $root.text($root.contents.asset_title + 's', null, false,
                                    'assets_title') }, true) }}
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div v-if="!updated" class="modal-footer">
            <span v-if="!updating">
                <span>
                    <button type="submit" class="btn btn-primary" @click="onSubmit()">
                        <i class="far fa-check mr-1"></i> {{ $root.text('Add', null, true) }}
                    </button>
                </span>
            </span>
            <span v-else>
                <button type="button" class="btn btn-primary">
                    <i class="fal fa-spinner-third fa-spin mr-1"></i>
                    <span style="opacity: 0.5">{{ $root.text('Add', null, true) }}</span>
                </button>
            </span>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                errors: false,
                updating: false,
                updated: false,
                folder_id: 0,
                folder_name: '',
                list_component: null,
                subfolder: {}
            }
        },
        mounted () {
            //
        },
        methods: {
            resetForm: function (folder, listComponent = null) {
                this.errors = false;
                this.updating = false;
                this.updated = false;
                this.folder_id = folder.id;
                this.folder_name = folder.name;
                this.list_component = listComponent;
                this.subfolder = {};
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                setTimeout(function () {
                    $('#subfolder-name').focus();
                }, 500);
            },
            onSubmit: function () {
                this.errors = false;
                this.updating = true;
                $('.mandatory-label').removeClass('text-danger');
                $('.mandatory-field').removeClass('field-error');

                /**
                 * Send request to API
                 */
                const data = this.subfolder;
                const url = this.$root.app.api_url + '/' + this.$root.app.client_id + '/folder/'
                    + this.folder_id + '/subfolder';
                var vm = this;

                axios({
                    method: 'post',
                    url: url,
                    data: data,
                    headers: { 'Authorization': 'Bearer ' + vm.$root.token }
                })
                .then(response => {
                    vm.updated = 'Success';
                    if (response.data.message) {
                        vm.updated = response.data.message;
                        vm.list_component.getSubfolders('!archived');
                    }

                    setTimeout(function () {
                        $('#subfolder-add-form-modal').modal('hide');
                    }, 2000);
                    vm.$root.folders_changed = true;
                })
                .catch(function (error) {
                    vm.errors = vm.$root.text('Something went wrong, please try again', null, true);
                    if (error.response) {
                        if (error.response.status == 401) {
                            // missing/lost API token - close modal and logout user
                            $('#subfolder-add-form-modal').modal('hide');
                            vm.$root.doLogout();
                        }
                        if (error.response.data.error) {
                            if (typeof error.response.data.error === 'string') {
                                vm.errors = error.response.data.error;
                            } else if (typeof error.response.data.error === 'object') {
                                vm.errors = '';
                                for (const [key, value] of Object.entries(error.response.data.error)) {
                                    vm.errors += value.join('<br>') + '<br>';
                                    $('#subfolder-' + key + '-label').addClass('text-danger');
                                    $('#subfolder-' + key).addClass('field-error');
                                }
                            }
                        }
                    }
                })
                .finally(() =>
                    vm.updating = false
                );
            }
        }
    }
</script>
